/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const create_user = /* GraphQL */ `
  mutation Create_user($input: userInputs) {
    create_user(input: $input)
  }
`;
export const edit_user = /* GraphQL */ `
  mutation Edit_user($input: userInputs) {
    edit_user(input: $input)
  }
`;
export const resend_invite = /* GraphQL */ `
  mutation Resend_invite($input: resendInviteInputs) {
    resend_invite(input: $input)
  }
`;
export const create_facility = /* GraphQL */ `
  mutation Create_facility($input: facilityInputs) {
    create_facility(input: $input)
  }
`;
export const edit_facility = /* GraphQL */ `
  mutation Edit_facility($input: facilityInputs) {
    edit_facility(input: $input)
  }
`;
export const add_users_to_facility = /* GraphQL */ `
  mutation Add_users_to_facility($input: facilityUsersInputs) {
    add_users_to_facility(input: $input)
  }
`;
export const delete_facility_users = /* GraphQL */ `
  mutation Delete_facility_users($input: facilityUsersInputs) {
    delete_facility_users(input: $input)
  }
`;
export const create_physician = /* GraphQL */ `
  mutation Create_physician($input: physicianInputs) {
    create_physician(input: $input)
  }
`;
export const edit_physician = /* GraphQL */ `
  mutation Edit_physician($input: physicianInputs) {
    edit_physician(input: $input)
  }
`;
export const create_affliation = /* GraphQL */ `
  mutation Create_affliation($input: affliationInputs) {
    create_affliation(input: $input)
  }
`;
export const edit_affliation = /* GraphQL */ `
  mutation Edit_affliation($input: affliationInputs) {
    edit_affliation(input: $input)
  }
`;
export const bulk_delete_affliations = /* GraphQL */ `
  mutation Bulk_delete_affliations($input: bulkDeleteAffliationsInput) {
    bulk_delete_affliations(input: $input)
  }
`;
export const create_resident = /* GraphQL */ `
  mutation Create_resident($input: residentsInputs) {
    create_resident(input: $input)
  }
`;
export const edit_resident = /* GraphQL */ `
  mutation Edit_resident($input: residentsInputs) {
    edit_resident(input: $input)
  }
`;
export const merge_residents = /* GraphQL */ `
  mutation Merge_residents($input: mergeResidentsInput) {
    merge_residents(input: $input)
  }
`;
export const transfer_resident = /* GraphQL */ `
  mutation Transfer_resident($input: transferResidentInput!) {
    transfer_resident(input: $input)
  }
`;
export const create_resident_medications = /* GraphQL */ `
  mutation Create_resident_medications($input: residentMedicationsInput) {
    create_resident_medications(input: $input)
  }
`;
export const edit_resident_medications = /* GraphQL */ `
  mutation Edit_resident_medications($input: updateResidentMedicationsInput) {
    edit_resident_medications(input: $input)
  }
`;
export const create_resident_recommendation = /* GraphQL */ `
  mutation Create_resident_recommendation($input: residentRecommendationInput) {
    create_resident_recommendation(input: $input)
  }
`;
export const update_multiple_resident_recommendation = /* GraphQL */ `
  mutation Update_multiple_resident_recommendation(
    $input: updateMultipleRecommendation
  ) {
    update_multiple_resident_recommendation(input: $input)
  }
`;
export const edit_resident_recommendation = /* GraphQL */ `
  mutation Edit_resident_recommendation($input: residentRecommendationInput) {
    edit_resident_recommendation(input: $input)
  }
`;
export const bulk_edit_resident_recommendation_outcome = /* GraphQL */ `
  mutation Bulk_edit_resident_recommendation_outcome(
    $input: bulkUpdateRecommendationOutcomeInput
  ) {
    bulk_edit_resident_recommendation_outcome(input: $input)
  }
`;
export const create_resident_notes = /* GraphQL */ `
  mutation Create_resident_notes($input: residentNotesInput) {
    create_resident_notes(input: $input)
  }
`;
export const edit_medication_logs = /* GraphQL */ `
  mutation Edit_medication_logs($input: medicationLogsInput) {
    edit_medication_logs(input: $input)
  }
`;
export const edit_recommendation_logs = /* GraphQL */ `
  mutation Edit_recommendation_logs($input: recommendationLogsInput) {
    edit_recommendation_logs(input: $input)
  }
`;
export const edit_organization = /* GraphQL */ `
  mutation Edit_organization($input: organizationInputs) {
    edit_organization(input: $input)
  }
`;
export const regenerate_organization_api_key = /* GraphQL */ `
  mutation Regenerate_organization_api_key(
    $input: regenerateOrganizationApiKeyInput
  ) {
    regenerate_organization_api_key(input: $input)
  }
`;
export const regenerate_organization_api_client_credentials = /* GraphQL */ `
  mutation Regenerate_organization_api_client_credentials(
    $input: regenerateOrganizationApiClientCredentialsInput
  ) {
    regenerate_organization_api_client_credentials(input: $input)
  }
`;
export const create_master_medications = /* GraphQL */ `
  mutation Create_master_medications($input: medicationInputs) {
    create_master_medications(input: $input)
  }
`;
export const edit_master_medications = /* GraphQL */ `
  mutation Edit_master_medications($input: medicationInputs) {
    edit_master_medications(input: $input)
  }
`;
export const create_category = /* GraphQL */ `
  mutation Create_category($input: categoryInputs) {
    create_category(input: $input)
  }
`;
export const edit_category = /* GraphQL */ `
  mutation Edit_category($input: categoryInputs) {
    edit_category(input: $input)
  }
`;
export const bulk_delete_categories = /* GraphQL */ `
  mutation Bulk_delete_categories($input: bulkDeleteCategoriesInput) {
    bulk_delete_categories(input: $input)
  }
`;
export const toggle_category_visibility = /* GraphQL */ `
  mutation Toggle_category_visibility($input: toggleCategoryVisibility) {
    toggle_category_visibility(input: $input)
  }
`;
export const create_template = /* GraphQL */ `
  mutation Create_template($input: templateInputs) {
    create_template(input: $input)
  }
`;
export const edit_template = /* GraphQL */ `
  mutation Edit_template($input: templateInputs) {
    edit_template(input: $input)
  }
`;
export const bulk_delete_templates = /* GraphQL */ `
  mutation Bulk_delete_templates($input: bulkDeleteTemplatesInput) {
    bulk_delete_templates(input: $input)
  }
`;
export const toggle_template_visibility = /* GraphQL */ `
  mutation Toggle_template_visibility($input: toggleTemplateVisibility) {
    toggle_template_visibility(input: $input)
  }
`;
export const create_lab_masters = /* GraphQL */ `
  mutation Create_lab_masters($input: labMastersInputs) {
    create_lab_masters(input: $input)
  }
`;
export const edit_lab_masters = /* GraphQL */ `
  mutation Edit_lab_masters($input: labMastersInputs) {
    edit_lab_masters(input: $input)
  }
`;
export const bulk_delete_lab_masters = /* GraphQL */ `
  mutation Bulk_delete_lab_masters($input: bulkDeleteLabMastersInput) {
    bulk_delete_lab_masters(input: $input)
  }
`;
export const toggle_lab_visibility = /* GraphQL */ `
  mutation Toggle_lab_visibility($input: toggleLabVisibility) {
    toggle_lab_visibility(input: $input)
  }
`;
export const generate_reports = /* GraphQL */ `
  mutation Generate_reports($input: reportsInputs) {
    generate_reports(input: $input)
  }
`;
export const delete_report = /* GraphQL */ `
  mutation Delete_report($input: deleteReportInputs) {
    delete_report(input: $input)
  }
`;
export const send_report_email = /* GraphQL */ `
  mutation Send_report_email($input: sendReportEmailInputs) {
    send_report_email(input: $input)
  }
`;
export const create_announcement = /* GraphQL */ `
  mutation Create_announcement($input: announcementInputs) {
    create_announcement(input: $input)
  }
`;
export const edit_announcement = /* GraphQL */ `
  mutation Edit_announcement($input: announcementInputs) {
    edit_announcement(input: $input)
  }
`;
export const announcement_views = /* GraphQL */ `
  mutation Announcement_views($input: announcementInputs) {
    announcement_views(input: $input)
  }
`;
export const save_report_to_cabinet = /* GraphQL */ `
  mutation Save_report_to_cabinet($input: saveReportInputs) {
    save_report_to_cabinet(input: $input)
  }
`;
export const create_folder = /* GraphQL */ `
  mutation Create_folder($input: fileFolderInputs) {
    create_folder(input: $input)
  }
`;
export const prepare_upload = /* GraphQL */ `
  mutation Prepare_upload($input: prepareUploadInput) {
    prepare_upload(input: $input)
  }
`;
export const rename_node = /* GraphQL */ `
  mutation Rename_node($input: fileFolderInputs) {
    rename_node(input: $input)
  }
`;
export const delete_node = /* GraphQL */ `
  mutation Delete_node($input: fileFolderInputs) {
    delete_node(input: $input)
  }
`;
export const create_user_invoice = /* GraphQL */ `
  mutation Create_user_invoice($input: invoiceInputs) {
    create_user_invoice(input: $input)
  }
`;
export const edit_user_invoice = /* GraphQL */ `
  mutation Edit_user_invoice($input: invoiceInputs) {
    edit_user_invoice(input: $input)
  }
`;
export const approve_reject_invoice = /* GraphQL */ `
  mutation Approve_reject_invoice($input: invoiceInputs) {
    approve_reject_invoice(input: $input)
  }
`;
export const delete_user_invoice = /* GraphQL */ `
  mutation Delete_user_invoice($input: invoiceInputs) {
    delete_user_invoice(input: $input)
  }
`;
export const create_master_checklist = /* GraphQL */ `
  mutation Create_master_checklist($input: MasterChecklistInput) {
    create_master_checklist(input: $input)
  }
`;
export const edit_master_checklist = /* GraphQL */ `
  mutation Edit_master_checklist($input: MasterChecklistInput) {
    edit_master_checklist(input: $input)
  }
`;
export const toggle_master_checklist_visibility = /* GraphQL */ `
  mutation Toggle_master_checklist_visibility(
    $input: toggleMasterChecklistVisibility
  ) {
    toggle_master_checklist_visibility(input: $input)
  }
`;
export const duplicate_checklist = /* GraphQL */ `
  mutation Duplicate_checklist($input: MasterChecklistInput) {
    duplicate_checklist(input: $input)
  }
`;
export const create_user_checklist = /* GraphQL */ `
  mutation Create_user_checklist($input: createChecklist1) {
    create_user_checklist(input: $input)
  }
`;
export const update_user_checklist = /* GraphQL */ `
  mutation Update_user_checklist($input: update_checklist1) {
    update_user_checklist(input: $input)
  }
`;
export const delete_user_checklist = /* GraphQL */ `
  mutation Delete_user_checklist($input: delete_user_checklist1) {
    delete_user_checklist(input: $input)
  }
`;
export const update_user_preference = /* GraphQL */ `
  mutation Update_user_preference($input: updateUserPreferenceInput) {
    update_user_preference(input: $input)
  }
`;
export const forget_user_devices = /* GraphQL */ `
  mutation Forget_user_devices {
    forget_user_devices
  }
`;
export const bulk_facility_operations = /* GraphQL */ `
  mutation Bulk_facility_operations($input: bulkFacilityOperationsInput) {
    bulk_facility_operations(input: $input)
  }
`;
export const bulk_user_facility_assignment = /* GraphQL */ `
  mutation Bulk_user_facility_assignment(
    $input: bulkUserFacilityAssignmentInput
  ) {
    bulk_user_facility_assignment(input: $input)
  }
`;
export const import_medications = /* GraphQL */ `
  mutation Import_medications($input: inputMedicationsInput) {
    import_medications(input: $input)
  }
`;
export const undo_import_medications = /* GraphQL */ `
  mutation Undo_import_medications($input: inputMedicationsInput) {
    undo_import_medications(input: $input)
  }
`;
export const delete_pdf_extraction = /* GraphQL */ `
  mutation Delete_pdf_extraction($input: deletePdfExtractionInput) {
    delete_pdf_extraction(input: $input)
  }
`;
export const create_resident_reminder = /* GraphQL */ `
  mutation Create_resident_reminder($input: residentRemindersInputs) {
    create_resident_reminder(input: $input)
  }
`;
export const edit_resident_reminder = /* GraphQL */ `
  mutation Edit_resident_reminder($input: residentRemindersInputs) {
    edit_resident_reminder(input: $input)
  }
`;
export const create_facility_reminder = /* GraphQL */ `
  mutation Create_facility_reminder($input: facilityRemindersInputs) {
    create_facility_reminder(input: $input)
  }
`;
export const edit_facility_reminder = /* GraphQL */ `
  mutation Edit_facility_reminder($input: facilityRemindersInputs) {
    edit_facility_reminder(input: $input)
  }
`;
export const create_facility_service = /* GraphQL */ `
  mutation Create_facility_service($input: facilityServicesInputs) {
    create_facility_service(input: $input)
  }
`;
export const edit_facility_service = /* GraphQL */ `
  mutation Edit_facility_service($input: facilityServicesInputs) {
    edit_facility_service(input: $input)
  }
`;
export const clear_facility_services = /* GraphQL */ `
  mutation Clear_facility_services($input: facilityServicesInputs) {
    clear_facility_services(input: $input)
  }
`;
export const create_resident_lab = /* GraphQL */ `
  mutation Create_resident_lab($input: residentLabsInputs) {
    create_resident_lab(input: $input)
  }
`;
export const edit_resident_lab = /* GraphQL */ `
  mutation Edit_resident_lab($input: residentLabsInputs) {
    edit_resident_lab(input: $input)
  }
`;
export const draft_ticket = /* GraphQL */ `
  mutation Draft_ticket($input: aiSupportAssistantInputs) {
    draft_ticket(input: $input)
  }
`;
export const create_ticket = /* GraphQL */ `
  mutation Create_ticket($input: ticketInputs) {
    create_ticket(input: $input)
  }
`;
export const edit_ticket = /* GraphQL */ `
  mutation Edit_ticket($input: ticketInputs) {
    edit_ticket(input: $input)
  }
`;
export const add_correspondence = /* GraphQL */ `
  mutation Add_correspondence($input: ticketInputs) {
    add_correspondence(input: $input)
  }
`;
export const edit_correspondence = /* GraphQL */ `
  mutation Edit_correspondence($input: ticketInputs) {
    edit_correspondence(input: $input)
  }
`;
export const get_upload_url = /* GraphQL */ `
  mutation Get_upload_url($input: getUploadUrlInput) {
    get_upload_url(input: $input)
  }
`;
